export enum LeadWillingness {
  NOW = 'NOW',
  IN_6_MONTHS = 'IN_6_MONTHS',
  UNKNOWN = 'UNKNOWN',
}
